<template lang="pug">
.readonly-mode-field(v-if="readonly") {{ fullLabel }}
el-cascader(ref="input", v-else, :value="cityValue", @input="setCity", separator="/", v-on="vm_listeners", clearable, :props="props")
</template>
<script>
import { CITY_ENUM, getArea, cityMap } from "./index.js";
export default {
  props: {
    value: { default: "", type: String },
    label: { default: "", type: String },
    level: { default: CITY_ENUM.max, type: Number },
    readonly: { default: false, type: Boolean }
  },
  data() {
    return {
      cityMap
    };
  },
  computed: {
    // 上级input事件本级不触发
    vm_listeners() {
      const {
        $listeners: { input, ...on }
      } = this;
      input;
      return on;
    },
    props() {
      return {
        lazy: true,
        lazyLoad: this.lazyLoadCityNode,
        value: "code",
        label: "name"
      };
    },
    cityCode() {
      return this.cityValue.slice(-1)[0];
    },
    cityValue() {
      const { value } = this;
      return value ? value.split(CITY_ENUM.splitter) : [];
    },
    fullLabel() {
      return this.label || this.getFullLabel(this.cityCode);
    }
  },
  watch: {
    cityValue: {
      immediate: true,
      async handler(val) {
        const { cityMap } = this;
        // 只有未加载的城市才会调用
        const codes = val.filter((code) => (code ? !cityMap[code] : false));
        if (codes.length) await Promise.all(["0", ...codes.slice(0, -1)].map((code) => this.loadCity(code)));
        this.withUpdate(this.cityCode);
        this.updateInputText();
      }
    }
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    async updateInputText() {
      // fix:外部处理值时.处理异步级联不显示的bug,多次尝试没办法了,只能强行赋值修改了
      const input = this.$refs.input;
      const path = this.fullLabel || "";
      await this.$nextTick();
      if (input && path && !input.presentText) {
        input.presentText = path;
      }
    },
    setCity(val) {
      const { cityMap } = this;
      const values = val || [];
      const code = values.slice(-1);
      const data = cityMap[code]?.codePath || "";
      this.$emit("input", data);
      this.withUpdate(code);
    },
    withUpdate(code) {
      const label = this.getFullLabel(code);
      this.$emit("update:label", label);
    },
    getFullLabel(code) {
      const { cityMap } = this;
      return cityMap[code]?.namePath;
    },
    // 加载数据
    async loadCity(pid, leaf = false) {
      const { cityMap } = this;
      const data = await getArea(pid);
      const list = [];
      for (const row of data) {
        this.$set(cityMap, row.code, row);
        list.push({ ...row, leaf });
      }
      return list;
    },
    async lazyLoadCityNode(node, resolve) {
      const { level } = this;
      const mustLeaf = level === node.level || node.level === CITY_ENUM.baseLevel;
      const pid = node.root ? 0 : node.value;
      let list = [];
      if (node.level <= level) list = await this.loadCity(pid, mustLeaf);
      resolve(list);
    }
  }
};
</script>
